import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 6.49999V5.09999L8 10.1L3 5.09999V6.49999L8 11.5L13 6.49999Z",
		fill: "currentColor"
	})
});
export default SvgChevronDown;
